import React from "react";

const GridCards = ({
  data = [],
  className = "",
  iconClass="rounded-full min-w-11 min-h-11 max-w-11 max-h-11 flex items-center justify-center",
  labelClass = "text-[10px] md:text-[12px] font-[Lato] font-[500] text-[#6C6A6ACC] text-center xl:text-start",
  valueClass = "text-[10px] md:text-[14px] font-[500] font-[Lato] text-[#6C6A6A] text-center xl:text-start",
  insideCardClass = "py-5 px-2 rounded-[17px] bg-white border border-[#E6E6E6] flex items-center flex-col xl:flex-row lg:justify-start gap-2 overflow-hidden",
}) => {
  return (
    <div className={className}>
      {data.map(({ label, icon, value, tabColor , unit }, index) => (
        <div
          key={index}
          className={insideCardClass}
          style={{
            boxShadow: "7px 7px 9.5px 0px #0000000D",
          }}
        >
          <div className="flex justify-center">
            <div
              className={iconClass}
              style={{ backgroundColor: tabColor }}
            >
              {icon}
            </div>
          </div>
          <div>
            <p className={labelClass}>{label}</p>
            <div>
              <p
                className={valueClass}
                style={{
                  wordBreak: "break-word",
                  hyphens: "auto",
                  overflowWrap: "break-word",
                }}
              >
                {value} {unit ? unit : ""}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GridCards;
